var auth = require('../auth');
var initNoCaptcha = require('../utils').initNoCaptcha;
require('./tmpl-renderer');

var VALID_SUCCESS = 'success.valid', VALID_ERROR = 'error.valid';

$.fn.ycLoginForm = function (globalOptions) {
    return this.each(function () {

        var $form = $(this);
        var $nc = $form.find('[role=yc-nc]');
        var $self = $(this);
        var options = $.extend({
            captchaDefaultHide: true,
            template: $self.next('script[type="text/x-template"]').length ? $self.next('script[type="text/x-template"]') : null
        }, globalOptions);

        if (options.template) {
            $self.on('success.submit', function () {
                $self.ycTmplRender({template: options.template});
            });
        }

        initNoCaptcha($nc, 'login');

        $self.on('blur', '[name=username]', function () {
            var self = $(this);
            var val = self.val();
            if (!val) {
                self.trigger(VALID_ERROR, ['请输入用户名']);
            } else {
                self.trigger(VALID_SUCCESS);
            }
        }).on(VALID_ERROR + ' ' + VALID_SUCCESS, 'input', function (e) {
            $(this).data('valid', e.type === 'success');
        }).on('blur', '[name=password]', function () {
            var self = $(this);
            if (!this.value) {
                self.trigger(VALID_ERROR, ['请输入密码']);
            } else {
                self.trigger(VALID_SUCCESS);
            }
        }).on('submit', function (e) {
            e.preventDefault();
            var username = this.username;
            var password = this.password;
            var $self = $(this);
            var ncResult = $nc.data('no-captcha');
            var canSubmit = true;
            if ($.isEmptyObject(ncResult)) {
                $self.trigger('error.submit', ['请操作滑动验证']);
                return;
            }

            $self.find('input[name]:enabled').each(function () {
                var $input = $(this);
                if ($input.data('valid') === false) {
                    this.focus();
                    canSubmit = false;
                    return false;
                } else if (!$input.data('valid')) {
                    $input.trigger('blur');
                    canSubmit = $input.data('valid');
                    if (!canSubmit) {
                        this.focus();
                        return false;
                    }
                }
            });

            if (canSubmit) {
                var defer = auth.login(username.value, password.value, ncResult).done(function (result) {
                    $self.trigger('success.submit', [result]);
                }).fail(function (xhr, msg, rs) {
                    $self.trigger('error.submit', [msg || rs.msg || '服务异常', xhr]);
                });
                defer.always(function () {

                    //初始化滑动验证码
                    initNoCaptcha($nc, 'login');

                    //删除defer 对象
                    $self.removeData('yc-defer');
                });

                //存储defer，用于其它使用
                $self.data('yc-defer', defer);
            }
        });
    });
};

$(function () {
    $('form[role~=yc-login-form]').ycLoginForm();
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/@ycgame/auth/src/plugins/login-form.js
// module id = 15
// module chunks = 1